import { FC, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import TaskCreateDrawer from '@/common/components/business/ExpandStore/TaskCreateDrawer';
import CircleTaskCreateDrawer from 'src/views/expandstore/pages/expansioncircletask/components/Edit/index';
import SemirTaskCreateDrawer from '@/views/expandstore/pages/expansioncirclesenmatask/components/Edit';
import ExpansionFranchiseeCircleTaskEditDrawer from '@/views/expandstore/pages/expansionFranchiseeCircleTask/pages/edit/Drawer';

/**
 * @Description 自动适配各种拓店任务模板下的创建
 *
 * 用法
 *
 * import AdaptiveTaskCreate from '@/common/components/business/ExpandStore/AdaptiveTaskCreate';
 *
 *      const [showCreateDrawer, setShowCreateDrawer] = useState<boolean>(false); // 创建拓店任务是否可见
 *
        showCreateDrawer && <AdaptiveTaskCreate
          showCreateDrawer={showCreateDrawer}
          setShowCreateDrawer={setShowCreateDrawer}
          businessInfo={detail}
          isBusiness={true}
          refresh={getDetail}
        />
 *
 */

const AdaptiveTaskCreate: FC<{
  showCreateDrawer,
  setShowCreateDrawer,
  businessInfo, // 商圈信息，加盟商任务模板忽略该字段
  isBusiness, // 是否来自商圈页，加盟商任务模板忽略该字段
  refresh
}> = ({
  showCreateDrawer,
  setShowCreateDrawer,
  businessInfo,
  isBusiness,
  refresh
}) => {
  const [taskTemplateCode, setTaskTemplateCode] = useState<string>('');
  const tenantCheckData = useSelector((state: any) => state.common.tenantCheck);
  const standardAndClusterEditRef = useRef<any>();

  useEffect(() => {
    const { taskTemplateCode } = tenantCheckData;
    taskTemplateCode && setTaskTemplateCode(taskTemplateCode);
  }, [tenantCheckData]);

  useEffect(() => {
    if (showCreateDrawer && taskTemplateCode === 'standardAndClusterA') {
      standardAndClusterEditRef.current?.init();
    }
  }, [showCreateDrawer, taskTemplateCode]);

  /** 加盟+直营模板时的关闭处理 */
  const onClose = () => {
    setShowCreateDrawer(false);
  };

  return (
    <>
      {/* 加盟任务模板 */}
      {taskTemplateCode === 'standardA' && <TaskCreateDrawer
        showDrawer={showCreateDrawer}
        setShowDrawer={setShowCreateDrawer}
        refresh={refresh}
      />}
      {/* 直营 */}
      {['clusterA', 'clusterB'].includes(taskTemplateCode) && <CircleTaskCreateDrawer
        showDrawer={showCreateDrawer}
        setShowDrawer={setShowCreateDrawer}
        businessInfo={businessInfo}
        isBusiness={isBusiness}
        refresh={refresh}
      />}
      {/* 森马模板 */}
      {taskTemplateCode === 'clusterC' && <SemirTaskCreateDrawer
        showDrawer={showCreateDrawer}
        setShowDrawer={setShowCreateDrawer}
        businessInfo={businessInfo}
        isBusiness={isBusiness}
        refresh={refresh}
      />}
      {/* 加盟+直营模板A */}
      {taskTemplateCode === 'standardAndClusterA' && <ExpansionFranchiseeCircleTaskEditDrawer
        ref={standardAndClusterEditRef}
        businessInfo={businessInfo}
        isBusiness={isBusiness}
        reload={refresh}
        onClose={onClose}/>}
    </>
  );
};

export default AdaptiveTaskCreate;
